import { typeCreatorV2 } from '../../../redux/utils/common';

export const SET_COUNTRY: string = typeCreatorV2(
  'SingleClientLocationReducer',
  'SetCountry'
);

export const SET_CITY: string = typeCreatorV2(
  'SingleClientLocationReducer',
  'SetCity'
);

export const SET_MUNICIPALITY: string = typeCreatorV2(
  'SingleClientLocationReducer',
  'SetMunicipality'
);

export const SET_LOCATON: string = typeCreatorV2(
  'SingleClientLocationReducer',
  'SetLocation'
);

export const UPDATE_LOCATON: string = typeCreatorV2(
  'SingleClientLocationReducer',
  'UpdateLocation'
);
